<div class="lds-css ng-scope">
  <div style="width:100%;height:100%" class="lds-eclipse">
    <div></div>
  </div>
</div>